const TINTS = [
  { bg: "#EDE6D4", line: "#CDC0A4" },
  { bg: "#E2E8DA", line: "#BCC9AE" },
  { bg: "#EAE2CE", line: "#D2C4A2" },
  { bg: "#DDE6E3", line: "#B5C8C2" },
];

export const Sprig = ({ className = "", style }) => (
  <svg
    viewBox="0 0 100 122"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    className={className}
    style={style}
  >
    <path d="M50 114 C 50 82, 50 46, 50 12" />
    <path d="M50 98 C 35 92, 28 77, 31 64 C 44 70, 50 84, 50 98 Z" />
    <path d="M50 98 C 65 92, 72 77, 69 64 C 56 70, 50 84, 50 98 Z" />
    <path d="M50 66 C 37 60, 31 47, 34 36 C 46 42, 50 54, 50 66 Z" />
    <path d="M50 66 C 63 60, 69 47, 66 36 C 54 42, 50 54, 50 66 Z" />
    <path d="M50 34 C 41 29, 37 19, 39 10 C 48 15, 51 25, 50 34 Z" />
    <path d="M50 34 C 59 29, 63 19, 61 10 C 52 15, 49 25, 50 34 Z" />
  </svg>
);

const ProductVisual = ({ product, variant = 0, className = "", zoomOnHover = false }) => {
  const hasPhoto = product.images && product.images.length > 0;

  if (hasPhoto && !product.forceLabel) {
    const src = product.images[variant % product.images.length];
    return (
      <div className={`overflow-hidden bg-[#EFEAE0] ${className}`}>
        <img
          src={src}
          alt={product.name}
          loading="lazy"
          className={`h-full w-full object-cover transition-transform duration-700 ease-out ${zoomOnHover ? "group-hover:scale-[1.04]" : ""}`}
        />
      </div>
    );
  }

  if (product.kind === "set") {
    return (
      <div className={`relative flex flex-col items-center justify-between overflow-hidden bg-ink p-6 text-cream ${className}`}>
        <div className="pointer-events-none absolute inset-3 border border-cream/15" />
        <p className="pt-1 text-[9px] uppercase tracking-[0.28em] text-sage">Sets & Gifting</p>
        <Sprig className="my-4 h-[30%] max-h-28 w-auto text-sage/60" />
        <div className="px-2 pb-1 text-center">
          <p className="font-serif italic font-light text-xl md:text-2xl leading-tight">{product.name}</p>
          <p className="mt-2 text-[9px] uppercase tracking-[0.24em] text-cream/50">
            {product.contents.length} together
          </p>
        </div>
      </div>
    );
  }

  const t = TINTS[(product.num ? parseInt(product.num, 10) : 0) % TINTS.length];
  return (
    <div className={`relative flex flex-col items-center justify-between p-5 md:p-7 text-ink ${className}`} style={{ backgroundColor: t.bg }}>
      <div className="pointer-events-none absolute inset-3 border" style={{ borderColor: t.line }} />
      <div className="flex w-full items-center justify-between px-1 pt-1 text-[9px] md:text-[10px] uppercase tracking-[0.28em] text-ink/60">
        <span>Ayushi</span>
        <span>№ {product.num}</span>
      </div>
      <Sprig className="my-3 h-[30%] max-h-32 w-auto" style={{ color: t.line }} />
      <div className="px-2 pb-1 text-center">
        <p className="font-serif italic font-light text-xl md:text-2xl leading-tight">{product.name}</p>
        <p className="mt-2 text-[9px] tracking-[0.2em] text-ink/45">{product.size}</p>
        {product.photoNote && (
          <p className="mt-2 text-[9px] uppercase tracking-[0.2em] text-ink/40">{product.photoNote}</p>
        )}
      </div>
    </div>
  );
};

export default ProductVisual;
